import { Form, GroupItem, Item } from 'devextreme-react/form';
import { useAppSelector, useAppDispatch } from '../../../contexts/hooks';
import { setMode, updateFieldOrder } from '../../../contexts/slices/orders';
import Toolbar, { Item as ItemToolBar } from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import { formatMessage } from 'devextreme/localization';
import { useCallback, useState } from 'react';
import { RenderImportedOrder } from '../../utils/render-imported-order/RenderImportedOrder';
import { RenderModeForm } from '../../utils/render-mode-form/RenderModeForm';
import { AddIcon, EditIcon, ordClinicalData, tracerModule, save, CreateOrders } from '../../../images/icons';
import { CustomFormControl } from '../../utils/form-render/FormRender';
//import { setHeightPanels } from '../../../contexts/slices/config';
import { useApiOrders } from '../../../api/api.orders';
import { LoadIndicator, LoadPanel, ScrollView, TextBox, Tooltip } from 'devextreme-react';
import { newToast } from '../..';
import { deleteIcon } from '../../../images/icons';
import { ModalNotes } from '../../utils/modal-notes/ModalNotes';
import { PopupInformation } from '../../utils/popup-information/PopupInformation';
import { TraceabilityPage } from '../../../pages';
import { TypeTableFilter } from '../../../types/types.system';
import { useApiFunctionsResult } from './OrderModules/Functions/Results';
import ModalCreatePreOrder from '../../../pages/Preorders/Modals/ModalCreatePreOrder';

const Index = () => {
  const dispatch = useAppDispatch();
  const Prm_OrdC = useAppSelector((x) => x.userInfo.Permissions?.Prm_OrdC);
  const Prm_OrdU = useAppSelector((x) => x.userInfo.Permissions?.Prm_OrdU);
  const Prm_OrdD = useAppSelector((x) => x.userInfo.Permissions?.Prm_OrdD);
  const [loading, setLoading] = useState<boolean>(false);
  const [modalDelete, setModalDelete] = useState<boolean>(false);
  const IdOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.IdOrder);
  const { OrderData, StudiesData } = useAppSelector((x) => x.globalOrders.CurrentOrder);
  // const EstadoConex = useAppSelector((x) => x.signalR.DataChangeIsconnected);
  const AutomaticOrder = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AutomaticOrder')[0].Cgn_Resultado);
  const { newOrder, updateOrder, deleteOrder, findOrder } = useApiOrders();
  const ColumnsOrdersCount = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsOrdersCount')[0])?.Cgn_Resultado;
  const data = useAppSelector((x) => x.globalOrders.CurrentOrder?.OrderData);
  const ActualMode = useAppSelector((x) => x.globalOrders.CurrentOrder.Mode);
  const mode = useAppSelector((x) => x.globalOrders.CurrentOrder.Mode);
  const Fields = useAppSelector((x) => x.configuration.Data?.SystemFields);
  const AditionalStudies = Fields?.filter((x) => x.Dfc_Tabla === 'Estudios');
  //const ModuleClinicalData = useAppSelector((x) => x.configuration.Data?.Config_General.find((x) => x.Cgn_Nombre === 'ModuleClinicalData')?.Cgn_Resultado);
  const ModuleClinicalData: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleClinicalData')[0].Cgn_Resultado) || 'false');
  const AutomaticBarcodePrint: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AutomaticBarcodePrint')[0])?.Cgn_Resultado || 'false');
  const { handlePrintBarcodesLabel } = useApiFunctionsResult();

  const Prm_Ord_Anamnesis_R = useAppSelector((x) => x.userInfo.Permissions?.Prm_Ord_Anamnesis_R);
  const Prm_Preordenes = useAppSelector((x) => x.userInfo.Permissions?.Prm_Preordenes);
  const Prm_Monitoreo = useAppSelector((x) => x.userInfo.Permissions?.Prm_Monitoreo);
  const AllowCreateOrdersAnotherLocation: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AllowCreateOrdersAnotherLocation')[0].Cgn_Resultado) || 'false');
  const AllowEditOrdersAnotherLocation: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'AllowEditOrdersAnotherLocation')[0].Cgn_Resultado) || 'false');
  const actualLocationOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.OrderData['Ord_Sd_Id']);
  const loginLocation = useAppSelector((x) => x.userInfo.Location);
  const [modalTrazabilidad, setModalTrazabilidad] = useState<boolean>(false);
  const [modalPreOrderVisible, setModalPreOrderVisible] = useState<boolean>(false);
  const [currentIdPreOrder, setCurrentIdPreOrder] = useState<number | null>(null);

  const info = useAppSelector((x) => x.configuration.Data?.SystemFields)
    ?.filter((x) => x.Dfc_Tabla === 'Ordenes' && x.Dfc_Estado === true && x.Dfc_Visible === true)
    .sort((a, b) => a.Dfc_Orden - b.Dfc_Orden);

  const handleEditClick = () => {
    if ((actualLocationOrd !== loginLocation && !AllowEditOrdersAnotherLocation) || !Prm_OrdU) {
      newToast('WARNING', formatMessage('OrdEditOrdDeny'), 5);
      return;
    }

    dispatch(setMode({ mode: 'update' }));
  };

  //#region ELIMINAR ORDEN
  const handleDelete = useCallback(() => {
    setModalDelete(true);
  }, []);

  const onConfirmDelete = useCallback(
    async (note: string) => {
      setModalDelete(false);
      setLoading(true);
      deleteOrder(note).finally(() => {
        setLoading(false);
      });
    },
    [IdOrd]
  );

  const onCancelDelete = useCallback(() => {
    setModalDelete(false);
  }, []);

  //#endregion

  const handleNewClick = () => {
    dispatch(setMode({ mode: 'new' }));
  };

  const onSaveClick = () => {
    if (mode === 'view') {
      return;
    }

    // Validar campos de ordenes.
    for (const element of info ?? []) {
      if (element.Dfc_Requerido && !element.Dfc_Dinamico && !OrderData[element.Dfc_Equivalencia]) {
        newToast('INFO', `El campo '${element.Dfc_Label}' es obligatorio`, 4);
        return; // Salir de la función
      }
      // Ahora los dinámicos
      if (element.Dfc_Requerido && element.Dfc_Dinamico && !OrderData.AditionalFields[element.Dfc_Equivalencia]) {
        newToast('INFO', `El campo '${element.Dfc_Label}' es obligatorio`, 4);
        return; // Salir de la función
      }
    }

    //Luego validamos que paciente esté asignado
    if (OrderData && !OrderData.Ord_Pc_Id) {
      newToast('INFO', formatMessage('OrdNotificationPatientReq'), 4);
      return;
    }
    //Luego validamos que hayan añadido al menos 1 estudio
    if (StudiesData.length === 0) {
      newToast('INFO', formatMessage('OrdNotificationStudieReq'), 4);
      return;
    }
    //Luego validamos los campos dinamicos de Orden Estudio Rompimiento.
    if (AditionalStudies) {
      //Primero se validan los estudios
      for (let i = 0; i < StudiesData.length; i++) {
        for (let i = 0; i < AditionalStudies.length; i++) {          
          const data = StudiesData[i]?.AditionalFields;
          if (AditionalStudies[i].Dfc_Requerido && (!data || !data[AditionalStudies[i].Dfc_Equivalencia])) {
            newToast('INFO', `${AditionalStudies[i].Dfc_Label} ${formatMessage('requiredField')} - ${StudiesData[i].Es_Nombre}`, 4);
            return;
          }
        }
      }
      //Luego se validan los perfiles
    }
    if (mode === 'new') {
      newOrder().then((res) => {
        if (res && AutomaticBarcodePrint) {
          handlePrintBarcodesLabel(res);
        }
      });
    }
    if (mode === 'update') {
      updateOrder();
    }
  };

  const onCancelClick = () => {
    if (mode === 'new') {
      dispatch(setMode({ mode: 'view', idOrd: -1 }));
      return;
    }
    findOrder(undefined, undefined, setLoading);
    //handleEditClick();
  };

  const setData = (field, castMode) => (value: string | number) => {
    dispatch(updateFieldOrder({ field, castMode, value: value }));
  };

  const onTraceOpen = useCallback(() => {
    setModalTrazabilidad(true);
  }, []);

  const handleClosePreOrder = useCallback(() => {
    setModalPreOrderVisible(false);
    setCurrentIdPreOrder(null);

  }, [setModalPreOrderVisible, setCurrentIdPreOrder]);

  const handleNewPreOrder = useCallback(() => {
    if (data && data.Ord_POrd_Id && data.Ord_POrd_Id >= 1) {      
      setCurrentIdPreOrder(data.Ord_POrd_Id);
      setModalPreOrderVisible(true);
    }
  }, [setModalPreOrderVisible, setCurrentIdPreOrder, data]);

  return (
    <div className='profile-card'>
      <LoadPanel shadingColor='rgba(0,0,0,0.4)' position={{ of: '#profile-card' }} visible={loading} showIndicator={true} shading={true} showPane={true} hideOnOutsideClick={false} />
      <ModalNotes visible={modalDelete} type='DeleteOrder' currentNote='' onConfirm={onConfirmDelete} onCancel={onCancelDelete} />
      <div className='profile-card-panel' style={{ height: '180px' }}>
        <div className='profile-card-panel-header'>
          <Toolbar>
            {/* <ItemToolBar location='before' visible={isLarge || isMedium}>
              <span className='title-text'>{formatMessage('OrdPanelOrder')}</span>
            </ItemToolBar> */}
            {IdOrd && IdOrd !== -1 && data && data.Ord_Importada && (
              <ItemToolBar location='before'>
                <RenderImportedOrder />
              </ItemToolBar>
            )}
            <ItemToolBar location='before'>
              <RenderModeForm mode={mode} />
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='before' showText='inMenu' locateInMenu='auto' visible={Prm_Preordenes && data && data.Ord_POrd_Id >= 1 && mode === 'view'}>
              <Button id='toolBarPreorder' text={'Ver preorden'} stylingMode='outlined' icon={CreateOrders} type='success' onClick={handleNewPreOrder} />
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='auto' visible={Prm_OrdC && mode === 'view' ? true : false}>
              <Button id='toolBarNew' text={'Nuevo'} stylingMode='outlined' icon={AddIcon} type='success' onClick={handleNewClick} />
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='auto' visible={IdOrd && IdOrd !== -1 && mode !== 'update' && Prm_OrdU ? true : false}>
              <Button id='toolBarEdit' text={'Editar'} icon={EditIcon} stylingMode='outlined' type='default' onClick={handleEditClick} />
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='auto' visible={mode === 'view' && IdOrd && IdOrd !== -1 && Prm_OrdD ? true : false}>
              <Button id='toolBarDelete' text={'Eliminar'} icon={deleteIcon} stylingMode='outlined' type='default' onClick={handleDelete} />
            </ItemToolBar>  
            <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='auto' visible={mode === 'new' || mode === 'update'}>
              <Button id='toolBarSave' text={'Guardar'} stylingMode='outlined' icon={save} type='default' onClick={onSaveClick} />
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='auto' visible={mode === 'new' || mode === 'update'}>
              <Button id='toolBarCancel' text={'Cancelar'} stylingMode='outlined' icon='close' type='danger' onClick={onCancelClick} />
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='auto'>
              <LoadIndicator visible={mode === 'loading'} height={23} width={23} />
            </ItemToolBar>
            {IdOrd && IdOrd !== -1 && (Prm_Ord_Anamnesis_R || Prm_Monitoreo) && (
              <ItemToolBar location='after' locateInMenu='auto'>
                <div className='separator' />
              </ItemToolBar>
            )}
            {IdOrd && IdOrd !== -1 && ModuleClinicalData && Boolean(ModuleClinicalData) && Prm_Ord_Anamnesis_R && (
              <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='auto'>
                <Button id='OrdClinicalData' text={'Datos clínicos'} stylingMode='outlined' icon={ordClinicalData} type='default' onClick={onCancelClick} />
              </ItemToolBar>
            )}
            {IdOrd && IdOrd !== -1 && Prm_Monitoreo && (
              <ItemToolBar widget='dxButton' location='after' showText='inMenu' locateInMenu='auto'>
                <Button id='menuTraceabilityOrd' text={'Trazabilidad'} stylingMode='outlined' icon={tracerModule} type='default' onClick={onTraceOpen} />
              </ItemToolBar>
            )}
          </Toolbar>
        </div>
        <ScrollView className='panelOrdenes' style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto', paddingBottom: '50px' }}>
          <div className='form-container' style={{ maxHeight: '80px' }}>
            <Form className='plain-styled-form'>
              <GroupItem colCount={ColumnsOrdersCount ? parseInt(ColumnsOrdersCount) : 1}>
                <Item>
                  <TextBox label={formatMessage('OrderField')} stylingMode='outlined' labelMode='static' value={data['Ord_Numero'] || ''} readOnly={ActualMode !== 'new' || Boolean(AutomaticOrder) ? true : false} />
                </Item>
                {info
                  ?.filter((x) => x.Dfc_Equivalencia !== 'Pc_Foto' && x.TipoCampo.Tcm_Equivalencia !== 'dxTextArea')
                  .sort((x) => x.Dfc_Orden)
                  .map((x) => {
                    const currentDep = info.find((y) => x.Dfc_DependencyDefinition === y.Dfc_Id)?.Dfc_Equivalencia;
                    if (x.Dfc_Equivalencia === 'Ord_Sd_Id' && !AllowCreateOrdersAnotherLocation) {
                      return (
                        <Item key={x.Dfc_Id} colSpan={x.Dfc_NroColumnas}>
                          <CustomFormControl value={data[x.Dfc_Equivalencia]} data={x} onValueChange={setData(x.Dfc_Dinamico ? `AditionalFields.${x.Dfc_Equivalencia}` : x.Dfc_Equivalencia, x.Dfc_Cast)} isEditing={AllowCreateOrdersAnotherLocation} />
                        </Item>
                      );
                    }
                    return (
                      <Item key={x.Dfc_Id} colSpan={x.Dfc_NroColumnas}>
                        {/* Anterior campo <CustomFormControl valueDepency={x.Dfc_Dependency ? data[`${x.Dfc_Dinamico && 'AditionalFields.'}${currentDep}`] : undefined} value={x.Dfc_Dinamico ? data.AditionalFields[x.Dfc_Equivalencia] : data[x.Dfc_Equivalencia]} data={x} onValueChange={setData(x.Dfc_Dinamico ? `AditionalFields.${x.Dfc_Equivalencia}` : x.Dfc_Equivalencia, x.Dfc_Cast)} isEditing={mode === 'new' || mode === 'update'} /> */}
                        <CustomFormControl valueDepency={x.Dfc_Dependency && currentDep && data.AditionalFields ? data.AditionalFields[currentDep] : undefined} value={x.Dfc_Dinamico && data.AditionalFields ? data.AditionalFields[x.Dfc_Equivalencia] || null : data[x.Dfc_Equivalencia]} data={x} onValueChange={setData(x.Dfc_Dinamico ? `AditionalFields.${x.Dfc_Equivalencia}` : x.Dfc_Equivalencia, x.Dfc_Cast)} isEditing={mode === 'new' || (mode === 'update' && x.Dfc_Editable) } />
                      </Item>
                    );
                  })}
              </GroupItem>
            </Form>
          </div>
        </ScrollView>
      </div>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#menuTraceabilityOrd'}>
        Trazabilidad
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#OrdClinicalData'}>
        Datos clínicos
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#filterButton'}>
        Filtrar
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarNew'}>
        Nuevo
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarPreorder'}>
        Ver preorden {data.Ord_POrd_Id || 0}
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarEdit'}>
        Editar
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarDelete'}>
        Eliminar
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarSave'}>
        Guardar
      </Tooltip>
      <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#toolBarCancel'}>
        Cancelar
      </Tooltip>
      {IdOrd && IdOrd !== -1 && Prm_Monitoreo && modalTrazabilidad && (
        <PopupInformation visible={modalTrazabilidad} handleClose={() => setModalTrazabilidad(false)} height={500} width={700} title={`Trazabilidad orden ${OrderData.Ord_Numero}`}>
          <div>
            <TraceabilityPage currentFilter={[{ TypeFilter: TypeTableFilter.Equal, Field: 'Mto_Ord_Id', Value: IdOrd }]} />
          </div>
        </PopupInformation>
      )}
      {currentIdPreOrder && currentIdPreOrder > 0 && <ModalCreatePreOrder visible={modalPreOrderVisible} idPreOrder={currentIdPreOrder} setVisible={handleClosePreOrder} />}
    </div>
  );
};

export default Index;
